import React, { useState, useEffect, useRef, useContext } from 'react';
import Floater from 'react-floater';
import { ThemeContext } from 'styled-components';
import { Scrollbars } from 'react-custom-scrollbars';
import * as s from './styled-more-errors';
import { icons, themes } from '../../assets';
import Progress from './progress';

const erros = [
  {
    label: 'Parque Semae',
    value: Math.random() * 100,
  },
  {
    label: 'Parque das Águas',
    value: Math.random() * 100,
  },
  {
    label: 'Estação Canoas',
    value: Math.random() * 100,
  },
  {
    label: 'Estação das Águas Porto Alegre',
    value: Math.random() * 100,
  },
  {
    label: 'Zona Sul',
    value: Math.random() * 100,
  },
  {
    label: 'Zona Sudeste',
    value: Math.random() * 100,
  },
];

const grandezas = [
  'Vazão',
  'Temperatura',
  'Pressão',
  'Potência',
  'Vibração',
  'Energia gerada',
  'Fator de serviço',
  'Corrente',
];

export default () => {
  const [grandeza, setGrandeza] = useState('');
  const [isOpen, setOpen] = useState(false);
  const floaterRef = useRef();
  const { colors } = useContext(ThemeContext);

  const renderTrack = ({ style }) => {
    const finalStyle = {
      ...style,
      width: 10,
      borderRadius: 16,
      background: `${colors.lightergrey}`,
      right: 2,
      bottom: 2,
      top: 2,
    };
    return <div style={finalStyle} />;
  };

  useEffect(() => {
    document.addEventListener('click', (e) => {
      if (
        floaterRef &&
        floaterRef.current &&
        !floaterRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    });
  }, []);

  const renderGrandezas = () => (
    <Scrollbars
      renderTrackVertical={renderTrack}
      renderThumbVertical={() => <s.ThumbVertical />}
      style={{ height: '175px', width: '100%' }}
    >
      {grandezas.map((label) => (
        <s.Option
          key={label}
          onClick={() => {
            setOpen(false);
            setGrandeza(label);
          }}
        >
          {label}
        </s.Option>
      ))}
    </Scrollbars>
  );

  return (
    <s.Container>
      <s.Line>
        <h5>Mais erros em</h5>
        <s.InputWrapper ref={floaterRef}>
          <s.InputLabel>{grandeza || 'Grandeza'}</s.InputLabel>
          <Floater
            open={isOpen}
            ref={floaterRef}
            styles={{
              container: {
                padding: 0,
                minHeight: 100,
              },
            }}
            disableAnimation
            hideArrow
            content={<>{renderGrandezas()}</>}
          >
            <s.InputIcon
              onClick={() => setOpen(!isOpen)}
              src={icons.PlayIcon}
            />
          </Floater>
        </s.InputWrapper>
      </s.Line>

      <Scrollbars
        renderTrackVertical={renderTrack}
        renderThumbVertical={() => <s.ThumbVertical opaque />}
        renderThumbHorizontal={() => <div style={{ display: 'none' }} />}
        style={{ height: '100%', width: '100%' }}
      >
        {erros.map(({ label, value }) => (
          <s.ErrorWrapper key={value}>
            <h5 style={{ marginBottom: 10 }}>{label}</h5>
            <Progress value={value} color={themes.red} />
          </s.ErrorWrapper>
        ))}
      </Scrollbars>
    </s.Container>
  );
};
